<template>
  <v-text-field
    :model-value="modelValue"
    :error-messages="
      modelValue == undefined || isNaN(modelValue) ? t('components.numberInput.error') : undefined
    "
    :label="t('components.numberInput.label')"
    @update:model-value="
      (input) => emit('update:modelValue', isNaN(parseFloat(input)) ? undefined : parseFloat(input))
    "
  />
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { modelValue } = defineProps<{ modelValue?: number }>();
const emit = defineEmits(["update:modelValue"]);
</script>
